/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * VolumeMuteIcon
 */
export default class VolumeMuteIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 4.414a2 2 0 011.995 1.851l.005.15v11.17a2 2 0 01-3.287 1.532L10.586 19l-3-3H5a2 2 0 01-1.995-1.85L3 14v-4a2 2 0 011.85-1.995L5 8h2.586l3-3A2 2 0 0112 4.414zm0 2L8.707 9.707a1 1 0 01-.576.284L8 10H5v4h3a1 1 0 01.608.206l.1.087L12 17.586V6.414zm4.613 2.796l.094.083L18 10.585l1.293-1.292a1 1 0 011.414 1.414L19.414 12l1.293 1.294a1 1 0 01-1.32 1.497l-.094-.083L18 13.414l-1.293 1.293a1 1 0 01-1.414-1.414l1.292-1.294-1.292-1.292a1 1 0 011.32-1.497z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

